import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaintenanceComponent } from '@core-app/layout/maintenance/maintenance.component';
import { MainComponent } from '@core-app/layout/main/main.component';
import { ClientService } from '@core-app/services/client.service';
import { PageComponent, PreviewComponent } from '@gallaghercp/core-frontend';
import { OopsComponent } from '@core-app/layout/oops/oops.component';
import { PostComponent } from '@core-app/layout/post/post.component';
import { LayoutModule } from './layout/layout.module';
import { LandingComponent } from '@core-app/layout/landing/landing.component';
import { CampusSelectGuard } from '@core-app/guards/campus-select.guard';

export const routes: Routes = [
    {
        path: 'maintenance',
        component: MaintenanceComponent,
    },
    {
        path: 'campus-select',
        component: LandingComponent,
    },
    {
        path: '404',
        pathMatch: 'full',
        component: OopsComponent,
    },
    {
        path: 'preview',
        component: MainComponent,
        children: [
            {
                path: '',
                component: PreviewComponent,
            },
        ],
    },
    {
        path: 'home',
        redirectTo: '/',
    },
    {
        path: 'articles/:identifier',
        component: MainComponent,
        canActivate: [CampusSelectGuard, ClientService],
        children: [
            {
                path: '',
                component: PostComponent,
            },
        ],
    },
    {
        path: '',
        component: MainComponent,
        canActivate: [CampusSelectGuard, ClientService],
        children: [
            {
                path: '',
                component: PageComponent,
                pathMatch: 'full',
            },
            {
                path: ':identifier',
                component: PageComponent,
            },
        ],
    },
    {
        path: '**',
        redirectTo: '404',
    },
];

@NgModule({
    imports: [
        LayoutModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
